export default __webpack_public_path__ + "static/media/ai-assistant.d08f4f8d.svg";